import { InputBase, InputBaseProps, InputAdornment } from "@mui/material";
import styles from "./textBox.module.css";
import CoreCopyButton from "../button/CopyButton";

type CoreTextBoxProps = {
	/** The height of the component. */
	height?: number | string;
	/** The width of the component.*/
	width?: number | string;
	/** The width of the component.*/
	outlineWidth?: string;
	/** Type of the `input` element. It should be a valid HTML5 input type. */
	type?: "text" | "number" | "email" | "password" | "search" | "tel" | "url";
	/** Show a copy button inside the text box */
	showCopyButton?: boolean;
	onCopy?: () => void;
	endAdornment?: React.ReactNode;
} & Omit<InputBaseProps, "color" | "type">;

export function CoreTextBox({
	height,
	width,
	outlineWidth,
	showCopyButton = false,
	onCopy,
	endAdornment,
	...props
}: CoreTextBoxProps) {
	return (
		<InputBase
			{...props}
			value={props.value}
			inputRef={props.inputRef}
			className={`${styles["CoreInputBox-root"]}`}
			sx={{
				...props.sx,
				height: height,
				maxHeight: height,
				width: width,
				...(outlineWidth && {
					outlineWidth: outlineWidth,
				}),
			}}
			slotProps={{
				input: {
					className: `${styles["CoreInputBox-input"]}`,
					sx: {
						maxHeight: height,
					},
				},
			}}
			endAdornment={
				<>
					{showCopyButton && (
						<InputAdornment position="end">
							<CoreCopyButton size="small" text={props.value?.toString() ?? ""} onCopy={onCopy} sx={{ mr: "15px" }} />
						</InputAdornment>
					)}
					{endAdornment}
				</>
			}
		/>
	);
}
